import React, { useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import agent from '../agent';
import { Button } from 'primereact/button';
import PasswordInput from "./Core/PasswordInput/PasswordInput";
import styles from "./ResetPassword.module.css";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = useMemo(() => searchParams.get('token') || '', [searchParams]);

  const [newPassword, setNewPassword] = useState('');
  const [repeatPassword, setRepeatPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const validate = () => {
    if (!token) return 'Неверная ссылка для сброса пароля (отсутствует токен).';
    if (!newPassword || !repeatPassword) return 'Пожалуйста, заполните оба поля пароля.';
    if (newPassword.length < 8) return 'Пароль должен содержать не менее 8 символов.';
    if (newPassword !== repeatPassword) return 'Пароли не совпадают.';
    return '';
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    const v = validate();
    if (v) { setError(v); return; }

    try {
      setSubmitting(true);
      await agent.Public.resetPassword({ token, newPassword, repeatPassword });
      setSuccess('Пароль успешно изменен. Сейчас вы будете перенаправлены на страницу входа.');
      setTimeout(() => navigate('/login', { replace: true }), 1500);
    } catch (e) {
      const msg = e?.error || e?.message || 'Не удалось изменить пароль. Попробуйте снова или запросите новую ссылку.';
      setError(typeof msg === 'string' ? msg : 'Ошибка при изменении пароля.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.glowOne} />
      <div className={styles.glowTwo} />

      <div className={styles.card}>
        <div className={styles.header}>
          <p className={styles.kicker}>Account Recovery</p>
          <h2>Сброс пароля</h2>
          <p className={styles.subtitle}>
            Укажите новый пароль для вашего аккаунта и подтвердите его.
          </p>
        </div>

        {!!error && (
          <div className={`p-message p-component p-message-error p-mb-3 ${styles.message}`} role="alert">
            <div className="p-message-wrapper">
              <span className="p-message-icon pi pi-times" />
              <span className="p-message-text">{error}</span>
            </div>
          </div>
        )}
        {!!success && (
          <div className={`p-message p-component p-message-success p-mb-3 ${styles.message}`} role="status">
            <div className="p-message-wrapper">
              <span className="p-message-icon pi pi-check" />
              <span className="p-message-text">{success}</span>
            </div>
          </div>
        )}

        <form onSubmit={onSubmit} className={styles.form}>
          <div className={styles.field}>
            <label htmlFor="new-password">Новый пароль</label>
            <PasswordInput
              id="new-password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              autoComplete="new-password"
              placeholder="Введите новый пароль"
              inputClassName="p-inputtext p-component"
            />
            <small className={styles.helpText}>Минимум 8 символов.</small>
          </div>
          <div className={styles.field}>
            <label htmlFor="repeat-password">Повторите пароль</label>
            <PasswordInput
              id="repeat-password"
              value={repeatPassword}
              onChange={(e) => setRepeatPassword(e.target.value)}
              autoComplete="new-password"
              placeholder="Повторите новый пароль"
              inputClassName="p-inputtext p-component"
            />
          </div>

          <Button
            type="submit"
            label={submitting ? 'Сохранение...' : 'Сохранить пароль'}
            icon={submitting ? 'pi pi-spin pi-spinner' : 'pi pi-lock'}
            disabled={submitting}
            className={styles.submitButton}
          />
        </form>

        <div className={styles.actions}>
          <Button label="Вернуться к входу" className="p-button-text" onClick={() => navigate('/login')} />
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
